import { SiteInfo } from "@/globals";
import { CategoryResponse } from "@/js/repository/CategoryRepository";
import { Menu, Search } from "lucide-react";
import { useRouter } from "next/router";
import { useState } from "react";
import { useTranslation } from "react-i18next";


export default function Header({ categories, setShowModal, setShowSearchModal }: any) {
    const { locale } = useRouter();
    const [showAllCategories, setShowAllCategories] = useState(false);
    const { t } = useTranslation();
    const sortedCategories = sortCategories(categories || []);
    const visibleCategoriesCount = locale === 'ru' ? 4 : 5;

  return (
    <header className="fixed w-full h-[60px] top-0 bg-black z-50">
      <ul className={`w-full flex flex-wrap h-[100%] items-center ${locale === 'es-ES' || locale === 'us' ? 'text-[0.825rem]' : 'text-sm'} text-white`}>
        {/* 메뉴버튼 */}
        <li className="lg:hidden">
          <button
            onClick={() => setShowModal(true)}
            className="p-2 ml-2"
            title={t("menu")}
          >
            <Menu size={24} />
          </button>
        </li>
        
        {/* 홈 버튼 */}
        <li key="Home" className="ml-2 lg:ml-8 mr-6 lg:text-[#fd384f] font-bold text-base">
          <a href="/">{SiteInfo.siteName}</a>
        </li>

        <li key="brands" className="mr-6 whitespace-nowrap hidden lg:block font-bold text-red-300">
          <a href="/brands">{t("brands")}</a>
        </li>

        {/* sm 이상일 때, visibleCategoriesCount까지의 카테고리만 표시 */}
        {sortedCategories.slice(0, visibleCategoriesCount).map((category: CategoryResponse) => (
          <li key={category.id} className="mr-6 whitespace-nowrap hidden lg:block">
            <a href={`/products?category=${category.id}`}
              onClick={() => setShowAllCategories(false)}
            >{category.name}</a>
          </li>
        ))}

        {sortedCategories.length > visibleCategoriesCount && (
          <li className="relative hidden lg:block">
            {/* 더보기 드롭다운 */}
            <button
              onClick={() => setShowAllCategories(!showAllCategories)}
              className="mr-6 whitespace-nowrap"
              title={t("more")}
            >
              {t("more")}
            </button>
            {showAllCategories && (
              <ul className={`absolute bg-white border mt-2 rounded shadow-lg z-10 text-black flex flex-wrap ${locale === 'ru' ? 'w-[640px] left-[-560px]' : 'w-[600px] left-[-520px]'}  2xl:left-0`}> {/* w-full 설정 */}
                {sortedCategories.slice(visibleCategoriesCount).map((category: CategoryResponse) => (
                  <li key={category.id} className="p-2 whitespace-nowrap w-1/2 box-border"> {/* box-border 설정 */}
                    <a
                      href={`/products?category=${category.id}`}
                      onClick={() => setShowAllCategories(false)}
                    
                    >
                      {category.name}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        )}

        {/* 검색 버튼 */}
        <li className="flex items-center ml-auto mr-4">
          <button
              onClick={() => setShowSearchModal(true)}
              title={t("search")}
            >
              <Search size={20} />
          </button>
        </li>
      </ul>
    </header>
  )
}

const sortCategories = (categories: any) => {
  // 우선순위가 높은 카테고리 ID를 배열로 정의
  const priorityOrder = [6, 7, 66, 200000345, 200000343];

  // 정렬 함수
  return categories.sort((a: CategoryResponse, b: CategoryResponse) => {
    // 우선순위에 따라 정렬
    const indexA = priorityOrder.indexOf(a.id);
    const indexB = priorityOrder.indexOf(b.id);

    if (indexA !== -1 && indexB !== -1) {
      // 둘 다 우선순위에 있는 경우 그 순서에 따라 정렬
      return indexA - indexB;
    } else if (indexA !== -1) {
      // a는 우선순위에 있지만 b는 없는 경우 a를 우선
      return -1;
    } else if (indexB !== -1) {
      // b는 우선순위에 있지만 a는 없는 경우 b를 우선
      return 1;
    } else {
      // 둘 다 우선순위에 없는 경우 가나다 순으로 정렬
      return a.name.localeCompare(b.name, 'ko');
    }
  });
};